import { createEventFactory } from '@cp/shared/tracking';

export const FavoriteEvents = {
  Favorite: createEventFactory({
    subject: 'client',
    action: 'favorite',
    goalId: 'nazhatie_knopki_dobavit_v_izbrannoe',
    goalName: 'Нажатие кнопки "Добавить в избранное"',
  }),
};
